import React, { useState } from 'react'

import { BackgroundToLightnessProvider, Spinner } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import * as styles from './index.vanilla.css'

const HIDE_MESSAGE_MS = 1500

export interface Props {
  saving: boolean
}

const Saving = ({ saving }: Props) => {
  const [stateText, setStateText] = useState<string | null>(null)
  const [showSpinner, setShowSpinner] = useState<boolean>(false)
  const [lastTimeout, setLastTimeout] = useState<NodeJS.Timeout | null>(null)

  const setSavingState = () => {
    setShowSpinner(true)
    setStateText(i18n.t('documents.viewer.saving'))
  }

  const disableSavingState = () => {
    setShowSpinner(false)
    setStateText(i18n.t('documents.viewer.saved'))

    setLastTimeout(setTimeout(() => setStateText(null), HIDE_MESSAGE_MS))
  }

  useEffect(() => {
    if (lastTimeout) clearTimeout(lastTimeout)

    if (saving) {
      setSavingState()
    } else {
      disableSavingState()
    }
  }, [saving])

  return (
    <div className={styles.savingState}>
      {showSpinner && (
        <BackgroundToLightnessProvider background="grey1000">
          <Spinner size="s24" />
        </BackgroundToLightnessProvider>
      )}

      {stateText}
    </div>
  )
}

export default Saving
